<template>
  <div class="anchor">
    <div class="mask" v-show="showMask">
      <div class="mask-container">
        <el-image src="https://live-oss.busionline.com/assets/images/avatars/png_meishengyin%402x.png"></el-image>
        <div class="mask-note">检测到您当前浏览器无法播放声音</div>
        <el-button type="primary" @click="openVolume">点击开启声音</el-button>
      </div>
    </div>
    <div class="live-container clearfix">
      <div class="live-main">
        <div class="live-main-left">
          <div class="channel-top">
            <div class="channel-name">{{channelInfo.title}}</div>
            <div class="channel-num">频道号:{{channelInfo.channel_id}}</div>
          </div>
          <div class="channel-main">
            <div class="channel-main-box">
              <div style="width: 100%; height: 100%;" v-if="showAliPlayer">
                <vue-aliplayer-v2 ref="VueAliplayerV2" :options="options" @ready="ready"/>
              </div>
              <el-image v-if="!showAliPlayer" style="width: 100%;" fit="contain" :src="channelCover"></el-image>
            </div>
          </div>
        </div>
        <div class="live-main-right">
          <div class="close-alert" v-if="isWSClose">
            <el-alert
              title="聊天室已断开，正在尝试重新连接...."
              type="error"
              effect="dark"
              center
              :closable="false">
            </el-alert>
          </div>
          <div class="close-alert" v-if="isWSError">
            <el-alert
              title="聊天室连接失败重连中...."
              type="error"
              effect="dark"
              center
              :closable="false">
            </el-alert>
          </div>
          <div class="live-comment">
            <div class="comment-top">
              <div class="comment-title">讨论区</div>
              <div class="online-num">
                在线人数：<span class="num">{{onlineCount}}</span>
              </div>
            </div>
            <div class="comment-main">
              <message-item
                v-for="(item, index) in messageList"
                :key="index"
                :messageItem="item"
                :selfId="userInfo.user_id"
              />
              <div v-if="chatBanned" class="chat-banned message-item">当前禁止发言，认真听课哦</div>
            </div>
            <div class="comment-bottom">
              <div class="comment-tools">
                <span class="emoji" :class="chatBanned?'btn-disabled':''" @click.stop="showEmoji"><i class="iconfont icon-icon_biaoqing"></i></span>
              </div>
              <transition name="fade">
                <custom-emoji v-if="showEmojiCom" class="emoji-component" @addemoji="addEmoji"/>
              </transition>
              <div class="comment-send">
                <div class="comment-input">
                  <el-input maxlength="100" class="input-field" @keyup.enter.native="sendMessage()" v-model="messageText" :disabled="chatBanned" :placeholder="chatBanned?'全体禁言中...':'请输入...'"/>
                </div>
                <el-button class="comment-btn" :class="chatBanned || !this.messageText?'btn-disabled':''" type="primary" @click.stop.prevent="sendMessage">发送</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import watchApi from '@/api/watch'
  import MessageItem from '@/components/MessageItem'
  import CustomEmoji from '@/components/CustomEmoji'
  import VueAliplayerV2 from "vue-aliplayer-v2";
  import {createSocket, sendWSPush, sendPing, closeSocket} from '@/utils/websocket'
  import {getStudentId,setStudentId,removeStudentId} from '@/utils/auth'

  export default {
    name: 'anchor',
    data() {
      return {
        messageList: [],
        showAliPlayer: false,
        options: {
          "width": "100%",
          "height": "100%",
          "source": "",
          "autoplay": true,
          "isLive": true,
          "rePlay": false,
          "playsinline": true,
          "preload": true,
          "controlBarVisibility": "hover",
          "useH5Prism": true,
          "flvFrameChasing": true,
          "skinLayout": [
            {
              "name": "errorDisplay",
              "align": "tlabs",
              "x": 0,
              "y": 0
            },
            {
              "name": "infoDisplay"
            },
            {
              "name": "controlBar",
              "align": "blabs",
              "x": 0,
              "y": 0,
              "children": [
                {
                  "name": "liveDisplay",
                  "align": "tlabs",
                  "x": 15,
                  "y": 6
                },
                {
                  "name": "fullScreenButton",
                  "align": "tr",
                  "x": 10,
                  "y": 13
                },
                {
                  "name": "subtitle",
                  "align": "tr",
                  "x": 10,
                  "y": 12
                },
                {
                  "name": "volume",
                  "align": "tr",
                  "x": 10,
                  "y": 10
                }
              ]
            }
          ]
        },
        channelId: '',
        showEmojiCom: false,
        messageText: '',
        userInfo: {},
        isWSClose: false,
        isWSError: false,
        chatBanned: false,
        channelInfo: {},
        onlineCount: '',
        player: null,
        liveStatus: '',
        queryParams: {},
        studnetId: '',
        showMask: false,
        isPushDown: false, //表示是否已经断流
        channelCover: 'https://live-oss.busionline.com/assets/images/avatars/png_weikaishi@2x.png'
      }
    },
    components: {
      MessageItem,
      VueAliplayerV2,
      CustomEmoji
    },
    created() {
      document.addEventListener('click', this.handlerShowEmoji)
      this.channelId = this.$route.query.channel_id
      this.queryParams = this.$route.query
      if(this.channelId){
        this.getChannelDetail()
      }
    },
    watch: {
      messageList: {
        handler() {
          this.$nextTick(() => {
            setTimeout(() => {
              // 显示数据的最后一行
              const lastItem = document.querySelector('.message-item:last-child')
              lastItem && lastItem.scrollIntoView()
            }, 0)
          })
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      getStudentId(){
        this.studnetId = getStudentId()
      },
      async getChannelDetail() {
        await this.getStudentId()
        watchApi.getChannelDetail(this.channelId).then(res => {
          if (res.code === 0) {
            let data = res.data
            this.channelInfo = data
            // 白名单观看 如果watch_info为空，有两种情况
            // 1：未登录 2：登录令牌过期，直接去登录页面
            //未登录： watch_info为空数组，x-student-id不存在
            //登录令牌过期 watch_info为空数组，x-student-id存在
            //第3种情况：存在x-accouont-id,讲师访问watch页面,watch_info返回讲师信息，x-student-id存在
            //第4种情况：存在x-student-id，但是这个学员不能看这个频道号的直播，需要重新登录去看直播
            if(data.auth_type === 'white_list'){
              if (!this.studnetId || (Array.isArray(data.watch_info) && this.studnetId)) {
                // 如果令牌过期了，需要先删除过期令牌
                removeStudentId()
                this.$router.push({path: '/watch/login',query: this.queryParams})
              }else{
                this.$store.commit('getWs', data.watch_info.ws)
                this.userInfo = data.watch_info
                this.successHandle()
              }
            }else if (data.auth_type === 'external') {
              // 外部授权观看 watch_info就是为空，要先外部授权验证
              if((Array.isArray(data.watch_info))){
                //直播频道不能观看
                this.$router.push('/UnAuthorize')
              }else{
                this.validateExternal()
              }
            }else{
              if(Array.isArray(data.watch_info)){
                // 需要先删除过期令牌
                removeStudentId()
                this.$router.push({path: '/watch/login',query: this.queryParams})
              }
            }
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 外部授权登录
      validateExternal(){
        let params = {
          user_id: this.queryParams.user_id,
          ts: this.queryParams.ts,
          sign: this.queryParams.sign
        }
        watchApi.validateExternalAuth(this.channelId,params).then(res => {
          if (res.code === 0) {
            let data = res.data
            setStudentId(data.session_id)
            this.$store.commit('getWs', data.ws)
            this.userInfo = data
            this.successHandle()
          }else{
            this.$router.push('/UnAuthorize')
          }
        }).catch(err=> {
          this.$router.push('/UnAuthorize')
          console.log(err)
        })
      },
      successHandle(){
        // 是否禁言
        if(this.channelInfo.is_silent == 1){
          this.chatBanned = true
        }else{
          this.chatBanned = false
        }
        //建立连接
        createSocket()
        //监听消息接收
        window.addEventListener('onmessageWS', this.getSocketData)
        window.addEventListener('oncloseWS', this.oncloseWS)
        window.addEventListener('onerrorWS', this.onerrorWS)
        // 获取直播链接 频道状态（0：已创建，未开始直播，1：直播中，2：直播结束）
        // 如果在直播中，直接显示直播组件
        this.liveStatus = this.channelInfo.status
        if(this.channelInfo.flv_url){
          this.options.source = this.channelInfo.flv_url
        }
        if(this.liveStatus == 1){
          this.showAliPlayer = true
          this.showMask = true
        } else if(this.liveStatus == 2){
          this.showAliPlayer = false
          this.showMask = false
          this.channelCover = 'https://live-oss.busionline.com/assets/images/avatars/png_yijieshu@2x.png'
        }else{
          this.showAliPlayer = false
          this.showMask = false
        }
      },
      showEmoji(){
        if(!this.chatBanned){
          this.showEmojiCom = !this.showEmojiCom
        }
      },
      addEmoji(emoji = '') {
        this.showEmojiCom = false
        this.messageText += emoji
      },
      // 点击表情选择表情
      handlerShowEmoji() {
        this.showEmojiCom = false
      },
      // 发送消息
      sendMessage() {
        if(this.chatBanned || !this.messageText){
          return
        }
        // 发送消息
        if(this.messageText){
          let _content = {
            "event": "chat_speak",
            "channel_id": this.channelId,
            "user_id": this.userInfo.user_id,
            "user_type": this.userInfo.user_type,
            "username": this.userInfo.username,
            "avatar": this.userInfo.avatar,
            "content": this.messageText
          };
          this.messageText = ''
          sendWSPush(_content)
        }else{
          this.$message.warning('请先输入内容！')
        }
      },
      getSocketData(e) {
        let data = JSON.parse(e.detail.data)
        let socketData = data.data
        switch (socketData.event) {
          case 'init':
            // 初始化
            let _content = {
              "event": "join_channel",
              "channel_id": this.channelId,
              "user_id": this.userInfo.user_id,
              "user_type": this.userInfo.user_type,
              "username": this.userInfo.username,
              "avatar": this.userInfo.avatar,
              "content": "加入频道"
            };
            sendWSPush(_content)
            sendPing(socketData.ping_interval)
            this.isWSClose = false
            this.isWSError = false
            break
          case 'live_publish':
            // 表示推流 直播开始，显示直播开始图片
            if(socketData.channel_id == this.channelId){
              this.showAliPlayer = true
              this.showMask = true
            }
            break
          case 'live_publish_done':
            // 表示断流 直播结束，显示直播结束图片
            if(socketData.channel_id == this.channelId){
              let that = this
              this.isPushDown = true
              setTimeout(function () {
                that.showAliPlayer = false
                that.showMask = false
                that.channelCover = 'https://live-oss.busionline.com/assets/images/avatars/png_yijieshu@2x.png'
              },5000)
            }
            break
          case 'join_channel':
            // 加入频道，获取评论列表
            if(socketData.channel_id == this.channelId){
              this.onlineCount = socketData.online_count
              this.messageList = socketData.comment_list
            }
            break
          case 'chat_speak':
            // 发言
            if(socketData.channel_id == this.channelId){
              this.messageList = [...this.messageList, socketData]
            }
            break
          case 'chat_banned':
            // 禁止发言
            if(socketData.channel_id == this.channelId){
              if(socketData.is_silent === '1'){
                this.chatBanned = true
              }else{
                this.chatBanned = false
              }
            }
            break
          case 'leaving_channel':
            if (socketData.channel_id == this.channelId) {
              this.onlineCount = socketData.online_count
            }
            break
          case 'force_leaving_channel':
            // 被暴力踢出
            if(socketData.channel_id == this.channelId && socketData.user_id == this.userInfo.user_id){
              window.removeEventListener('onmessageWS', this.getSocketData)
              window.removeEventListener('oncloseWS', this.oncloseWS)
              window.removeEventListener('onerrorWS', this.onerrorWS)
              // 关闭socket
              closeSocket()
              this.isWSClose = false
              this.isWSError = false
              this.$confirm('您已被踢出直播间，请重新登录！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                showCancelButton: false,
                showClose: false,
                type: 'warning'
              }).then(() => {
                removeStudentId()
                location.reload()
              })
            }
            break
          default:
            break
        }
      },
      oncloseWS() {
        this.isWSClose = true
      },
      onerrorWS() {
        this.isWSError = true
      },
      ready() {
        this.$nextTick(() => {
          this.$refs.VueAliplayerV2.setVolume(0)
          this.$refs.VueAliplayerV2.play()
        })
      },
      openVolume() {
        this.$refs.VueAliplayerV2.setVolume(0.5)
        this.showMask = false
      }
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handlerShowEmoji)
      window.removeEventListener('onmessageWS', this.getSocketData)
      window.removeEventListener('oncloseWS', this.oncloseWS)
      window.removeEventListener('onerrorWS', this.onerrorWS)
      // 关闭socket
      closeSocket()
      this.isWSClose = false
      this.isWSError = false
    },
  }
</script>
<style lang="scss" scoped>
  .anchor {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 45vw;
    min-width: 1000px;
    background: #000000;
    padding: 90px 0;
    box-sizing: border-box;
  }
  .mask{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 99;
    .mask-container{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
      .mask-note{
        color: #fff;
        margin-top: 32px;
        margin-bottom: 40px;
      }
    }
  }
  .live-container {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    overflow: hidden;
    background-color: #fff;
    .live-main {
      .live-main-left {
        width: 100%;
        padding-right: 360px;
        box-sizing: border-box;
        color: #fff;
        overflow: hidden;

        .channel-top {
          position: relative;
          width: 100%;
          height: 64px;
          font-size: 16px;
          line-height: 64px;
          padding: 0 24px;
          box-sizing: border-box;
          background: #fff;
          color: #333333;

          .channel-name {
            float: left;
            width: 70%;
            font-size: 22px;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .channel-num {
            position: absolute;
            right: 24px;
            top: 0;
          }
        }

        .channel-main {
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 56.25%;
          box-sizing: border-box;
          overflow: hidden;

          .channel-main-box {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }
        }
      }

      .live-main-right {
        position: absolute;
        right: 0;
        top: 0;
        width: 360px;
        height: 0;
        padding-bottom: calc(56.25% - 138.5px);
        background: #F7F7F7;
        color: #fff;
        .close-alert{
          position: absolute;
          width: 100%;
          z-index: 1;
        }
        .live-comment {
          .comment-top {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 64px;
            font-size: 22px;
            padding: 28px 16px 0 16px;
            box-sizing: border-box;
            color: #333333;
            background: #fff;
            border-bottom: 1px solid #DCDFE6;
            border-left: 1px solid #DCDFE6;

            .comment-title {
              font-weight: 500;
              line-height: 22px;
            }

            .online-num {
              position: absolute;
              right: 16px;
              top: 32px;
              font-size: 14px;
              line-height: 14px;
              color: #999;

              .num {
                color: #1DCA4A;
              }
            }
          }

          .comment-main {
            position: absolute;
            left: 0;
            top: 64px;
            bottom: 108px;
            padding: 26px 16px;
            overflow-y: auto;
            width: 100%;
            box-sizing: border-box;

            &::-webkit-scrollbar {
              color: transparent;
            }

            &::-webkit-scrollbar-button {
              color: transparent;
            }

            &::-webkit-scrollbar-thumb {
              color: transparent;
            }

            &::-webkit-scrollbar-track {
              color: transparent;
            }

            &::-webkit-scrollbar-track-piece {
              color: transparent;
            }

            &::-webkit-scrollbar-corner {
              color: transparent;
            }

            &::-webkit-resizer {
              color: transparent;
            }
            .chat-banned{
              width: 216px;
              height: 32px;
              background: #B8BDC2;
              border-radius: 16px;
              font-size: 14px;
              text-align: center;
              line-height: 32px;
              color: #fff;
              margin: 40px auto 0;
            }
          }

          .comment-bottom {
            position: absolute;
            left: 0;
            bottom: 0;
            height: 108px;
            width: 100%;
            background: #fff;
            padding: 0 16px;
            box-sizing: border-box;
            border-top: 1px solid #DCDFE6;

            .comment-tools {
              padding: 10px 0;
              .btn-disabled{
                opacity: 0.5;
                cursor: not-allowed;
                .iconfont{
                  &::before {
                    cursor: not-allowed;
                  }
                }
              }

              .iconfont {
                font-size: 26px;
                color: #BEBEBE;
                cursor: pointer;

                &:hover {
                  color: #1678FF;
                }
              }
            }

            .comment-send {
              .comment-input {
                float: left;
                margin-right: 8px;

                .input-field {
                  width: 236px;
                  height: 48px;
                  background: #FFFFFF;
                  border-radius: 4px;

                  ::v-deep .el-input__inner {
                    height: 48px;
                    line-height: 48px;
                    font-size: 14px;
                    color: #333333;
                    border-color: #D8DCE6;
                  }
                }
              }

              .comment-btn {
                float: left;
                width: 84px;
                height: 48px;
                font-size: 18px;
                &.btn-disabled{
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }

      .emoji-component {
        position: absolute;
        bottom: 98%;
        left: 11px;
        width: 338px;
      }
    }
  }
  .prism-player{
    ::v-deep .prism-controlbar-bg{
      background: rgba(75,75,75,.5) !important;
    }
  }
</style>
